import React from 'react';
import { IconUpDownArrows } from 'design-system/icons';
const IconTransfer = ({ ...props }) => (<IconUpDownArrows direction="left" {...props}/>);
export default IconTransfer;
